<template>
    <div class='container'>
        <div class='clause'>
            <!-- <h3 class='text text-center'>{{instructions.title}}</h3> -->
            <p>{{instructions.abstraction}}</p>
            <div class='clause-section' v-for='(clause, index) in instructions.protocols' :key='`clause-${index}`'>
                <h4 v-if='clause.name'>{{clause.name}}</h4>
                <p v-if='clause.intro'>{{clause.intro}}</p>
                <div v-for='(item, index) in clause.list' :key='`item-${index}`'>
                    <p>{{index + 1}}、{{item.text}}</p>
                </div>
            </div>
            <footer class='text text-right text-small'>
                以上内容，六六找房平台具有最终解释权。
            </footer>
        </div>
    </div>
</template>

<script>
    import { LODGING_INSTRUCTION } from '@/clause/instruction/lodging'

    export default {
        data () {
            return {
                instructions: LODGING_INSTRUCTION
            }
        }
    }
</script>
